const drawer = document.getElementById("drawer");
document.getElementById("drawer-cart-list");

// Cart Event Listeners ########################################################
// #############################################################################

function addDrawerEventListeners() {
  // Refresh buttons and re-add event listeners
  const openDrawerButton = document.getElementById("open-drawer-button");
  const closeDrawerButton = document.getElementById("close-drawer-button");
  const closeDrawerBackdrop = document.getElementById("close-drawer-backdrop");
  openDrawerButton.addEventListener("click", () => {
    drawer.classList.add("active");
  });
  closeDrawerButton.addEventListener("click", () => {
    drawer.classList.remove("active");
  });
  closeDrawerBackdrop.addEventListener("click", () => {
    drawer.classList.remove("active");
  });
  const removeItems = document.querySelectorAll('.remove-item-form');
  removeItems.forEach(item => {
    item.addEventListener('click', remove_item);
  });
  const incrementItems = document.querySelectorAll('.increment-item-form');
  const decrementItems = document.querySelectorAll('.decrement-item-form');
  incrementItems.forEach(item => {
    item.addEventListener('click', increment_item);
  });
  decrementItems.forEach(item => {
    item.addEventListener('click', decrement_item);
  });
  return;
}
addDrawerEventListeners();

// Drawer Updates ##############################################################
// #############################################################################

function updateDrawer(action) {
  // Update cart counter
  document.getElementById("cart-counter");
  cartData.cart.items.length;
  /* cartCounter.innerText = counter; */
  // Update drawer section
  fetch(window.Shopify.routes.root + "?sections=section-drawer").then(resp => resp.json()).then(res => {
    const parser = new DOMParser();
    const el = parser.parseFromString(res["section-drawer"], "text/html");
    document.querySelector(".drawer").innerHTML = "";
    document.querySelector(".drawer").innerHTML = el.getElementById("drawer").innerHTML;
  }).then(() => {
    addDrawerEventListeners();
    if (action) {
      drawer.classList.add("active");
    }
  });
}

// Cart counter ################################################################
// #############################################################################

const cartProxy = new Proxy(window.cartData, {
  set: function (target, key, value) {
    /* 		const cartCounter = document.getElementById("cart-counter");
    		cartCounter.innerText = value.length; */
    // Add drawer update
    target[key] = value;
    updateDrawer(false);
    return true;
  }
});
const addToCartProxy = new Proxy(window.cartData, {
  set: function (target, key, value) {
    // Add drawer update & open
    target[key] = value;
    updateDrawer(true);
    return true;
  }
});
window.onload = () => {
  fetch(window.Shopify.routes.root + "cart.js").then(response => response.json()).then(result => {
    cartProxy.cart = result;
  });
};

// Cart actions ################################################################
// #############################################################################

async function add_cart(e) {
  // Prevent defaults action (used to avoid refresh on form submit)
  e.preventDefault();
  // e.target is the element of the event and allow us to access element data such as dataset.
  //const formData = new FormData(e.target);
  const formElem = e.target; // Find the element by its data-scr
  const id = formElem.querySelector('[name="id"]:checked');
  e.target.dataset.price;
  const qty = formElem.querySelector('[name="quantity"]').value;
  let formData = {
    items: [{
      id: id.value,
      quantity: qty
    }],
    attributes: {
      // Add here custom attributes
    }
  };
  await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  }).then(response => {
    console.log(response);
    if (response.status === 200) {
      fetch(window.Shopify.routes.root + 'cart.js').then(response => response.json()).then(result => {
        addToCartProxy.cart = result;
        updateDrawer(true);
        return;
      }).catch(error => {
        console.log(error);
      });
    }
  });
}
async function remove_item(event) {
  let formData = {
    id: event.target.dataset.variant,
    quantity: 0
  };
  fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: {
      "content-Type": "application/json"
    },
    body: JSON.stringify(formData)
  }).then(response => {
    console.log("Remove product form submitted.");
    fetch(window.Shopify.routes.root + "cart.js").then(response => response.json()).then(result => {
      addToCartProxy.cart = result;
      return;
    });
  }).catch(error => {
    console.error(error);
  });
}
async function increment_item(event) {
  let formData = {
    id: event.target.dataset.variant,
    quantity: Number(event.target.dataset.qty) + 1
  };
  fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: {
      "content-Type": "application/json"
    },
    body: JSON.stringify(formData)
  }).then(response => {
    console.log("Increment product form submitted.");
    fetch(window.Shopify.routes.root + "cart.js").then(response => response.json()).then(result => {
      addToCartProxy.cart = result;
      return;
    });
  }).catch(error => {
    console.error(error);
  });
}
async function decrement_item(event) {
  let formData = {
    id: event.target.dataset.variant,
    quantity: Number(event.target.dataset.qty) - 1
  };
  fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: {
      "content-Type": "application/json"
    },
    body: JSON.stringify(formData)
  }).then(response => {
    console.log("Decrement product form submitted.");
    fetch(window.Shopify.routes.root + "cart.js").then(response => response.json()).then(result => {
      addToCartProxy.cart = result;
      return;
    });
  }).catch(error => {
    console.error(error);
  });
}

// Product add to cart event listeners #########################################
// ##########################################################################

const forms = document.querySelectorAll(".shopify-product-form");
if (forms) {
  console.log('Product form found.');
  forms.forEach(form => {
    form.addEventListener("submit", event => {
      add_cart(event);
    });
  });
}
